module.exports = __webpack_public_path__ + "static/media/both.3ad378a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/both.svg
// module id = 189
// module chunks = 0